import { loc } from "../i18n/survey";

enum Motivation {
  CONFIDENCE = 'Confidence',
  HEALTH = 'Health',
  FEEL_BETTER = 'Feel Better',
  PROVE_CAPABLE = 'Prove Capable',
}

const motivationQuestion = {
  name: 'motivation',
  type: 'radiogroup',
  // showOtherItem: true,
  isRequired: true,
  colCount: 1,
  title: loc("quiz.motivation.title"),
  description: loc("quiz.motivation.description"),
  choices: [
    { value: Motivation.CONFIDENCE, text: loc("quiz.motivation.choices.confidence") },
    { value: Motivation.HEALTH, text: loc("quiz.motivation.choices.health") },
    { value: Motivation.FEEL_BETTER, text: loc("quiz.motivation.choices.feelBetter") },
    { value: Motivation.PROVE_CAPABLE, text: loc("quiz.motivation.choices.proveCapable") },
  ],
};

export {
  motivationQuestion,
  Motivation,
}